import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType, } from '../../constants';

export class GaTrackingRegisterWithEmailButtonClickEvent implements GATrackingEvent {

  constructor(
    private event: string,
    private category: string,
    private label: string,
    private action: string) { }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.RegisterWithEmailButtonClicked;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.RegisterWithEmailButtonClicked,
      category: this.category,
      label: this.label,
      gtmCustom: {
        action: this.action,
      }
    };
  }
}
